import axios from "axios";

export const fetchMaintenanceMessages = () => {
  return (dispatch) => {
    axios.get("/facility_maintenances").then((response) => {
      const data = response.data;
      // If response is { rows: [...] }, use rows; else use data directly
      const messages = Array.isArray(data) ? data : (Array.isArray(data.rows) ? data.rows : []);
      dispatch({
        type: "FETCH_MESSAGES",
        messages,
      });
    });
  };
};

export const addMaintenanceMessage = (message) => {
  return (dispatch, getState) => {
    axios.post("/facility_maintenances", message).then(() => {
      dispatch({
        type: "ADD_MESSAGE",
      });
      dispatch(fetchMaintenanceMessages());
    });
  };
};

export const updateMaintenanceMessage = (message) => {
  return (dispatch) => {
    axios.put("/facility_maintenances/" + message.id, message).then(() => {
      dispatch({
        type: "UPDATE_MESSAGE",
      });
      dispatch(fetchMaintenanceMessages());
    });
  };
};

export const removeMaintenanceMessage = (id) => {
  return (dispatch) => {
    axios.delete("/facility_maintenances/" + id).then(() => {
      dispatch({
        type: "REMOVE_MESSAGE",
      });
      dispatch(fetchMaintenanceMessages());
    });
  };
};

export const selectMaintenanceMessage = (message) => {
  return (dispatch) => {
    dispatch({
      type: "SELECT_MESSAGE",
      message,
    });
  };
};
